import type { IconProps } from '.';

/**
 * Play Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const PlayIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.5 12L7 4.20578L7 19.7942L20.5 12ZM18.5 12L8 5.93783L8 18.0622L18.5 12Z"
      fill="white"
    />
  </svg>
);

export default PlayIcon;
